exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".react-bootstrap-table-page-btns-ul{\n\nmargin-left: 40%;\n}", ""]);

// exports
